import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-flow-character-selection-modal',
    templateUrl: './flow-character-selection-modal.component.html',
    styleUrls: ['./flow-character-selection-modal.component.scss']
})
export class FlowCharacterSelectionDialogComponent implements OnInit {

    public characterList = [];
    public primaryCharacter = [];
    public selectedOpeningAct = [];
    public openingActList = [];
    public showStepCharacters: boolean = false;
    public showStepOpeningAct: boolean = false;
    public isCharactersDisabled: boolean = false;
    public isOpeningActDisabled: boolean = false;

    private allCharacters = [];
    private allOpeningActs = [];

    constructor(public dialogRef: MatDialogRef<FlowCharacterSelectionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.characterList = data.characterList;
        this.openingActList = data.openingActs;
        this.allCharacters = data.characterList;
        this.allOpeningActs = data.openingActs;
        this.showStepCharacters = data.showStepCharacters;
        this.showStepOpeningAct = data.showStepOpeningAct;
    }

    ngOnInit(): void {

    }

    drop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex,
            );

            if (this.primaryCharacter.length >= 1) {
                this.isCharactersDisabled = true;
            }
            else
                this.isCharactersDisabled = false;

            if (this.selectedOpeningAct.length >= 1) {
                this.isOpeningActDisabled = true;
            }
            else
                this.isOpeningActDisabled = false;
        }
    }

    randomizeCharacters() {
        this.characterList = this.allCharacters;
        this.primaryCharacter = [this.characterList[Math.floor(Math.random() * this.characterList.length)]];
        this.characterList = this.characterList.filter(i => i._id !== this.primaryCharacter[0]._id);
        this.isCharactersDisabled = true;
    }

    randomizeOpeningActs() {
        this.openingActList = this.allOpeningActs;
        this.selectedOpeningAct = [this.openingActList[Math.floor(Math.random() * this.openingActList.length)]];
        this.openingActList = this.openingActList.filter(i => i._id !== this.selectedOpeningAct[0]._id);
        this.isOpeningActDisabled = true;
    }

    startTraining() {
        this.dialogRef.close([this.primaryCharacter[0], this.selectedOpeningAct[0]]);
    }
}